import _toNumber from 'lodash-es/toNumber';
import _toString from 'lodash-es/toString';
import _toUpper from 'lodash-es/toUpper';

import { Yii } from "libraries/interfaces/Yii";

import { EventEmitter, Input, Output, ViewChild, Directive } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { IValidator } from '../forms/utils/validators/IValidator';
import { AutoComplete } from "primeng/autocomplete";


/**
 * Contract Generic field
 */
export interface IGenericField {
    controlName: string | number;
    group: FormGroup;
}

/**
 * GenericField: Shared variables and functions fields
 * @deprecated
 */
@Directive()
export abstract class GenericField {
    @Input()
    public error: {
        message: string,
        condition: string
    } = { message: '', condition: '' };

    /** Group */
    @Input()
    public group: FormGroup;

    @Input()
    public disabled: boolean = false;

    @Input()
    public required: boolean = false;

    @Input()
    public hasError: boolean = false;

    /** FormControlName */
    @Input()
    public controlName: any;

    /** FormControlName */
    @Input()
    public isInArray: boolean = false;

    @Input()
    public styleForm: string = '';

    @Input()
    public defaultValue: any;
    @Input()
    public appendTo: string;

    /** Icon */
    @Input()
    public icon: string = '';

    /** Placeholder */
    @Input()
    public placeholder: string;

    /** Label */
    @Input()
    public label: string;
    /** Label */
    @Input()
    public labelField: string; // <- used in checkbox


    /** Label */
    @Input()
    public labelLeft: string;

    /** NUMBER FIELD */
    @Input()
    public min: number = 1;

    /** NUMBER FIELD */
    @Input()
    public max: number;
    /** NUMBER FIELD */
    @Input()
    public step: number = 1;

    @Input()
    public index: number;

    /**
     * usage contexts :
     * autocomplete,  multiselect
     * + chipSelect
     */
    @Input()
    public options: any = {};

    @Input()
    public parsingValueLocation: string;
    @Input()
    public parsingNameLocation: string;
    @Input()
    public parsingCodeLocation: string;

    @Input()
    public cardinality: string;

    @Input()
    public nbItems: number;

    @Input()
    public type: string = 'text';

    @Input()
    public filter: boolean = false;

    /** calendar input */
    @Input()
    public minDate: any = "";
    @Input()
    public maxDate: any = "";
    @Input()
    public validators: IValidator[] = [];
    @Input()
    public defaultDate: any;
    @Input()
    public monthNavigator: any = false;
    @Input()
    public yearNavigator: any = false;
    @Input()
    public yearRange: string;
    @Input()
    public past: boolean = false;

    @Output() public select: EventEmitter<boolean> = new EventEmitter();
    @Output()
    public selectDate: EventEmitter<any> = new EventEmitter();

    @Output()
    public change = new EventEmitter();

    @Output()
    public inputChange = new EventEmitter();

    @Output()
    public blur: EventEmitter<any> = new EventEmitter();
    @Output()
    public focus: EventEmitter<any> = new EventEmitter();

    @Output()
    public keyUp: EventEmitter<any> = new EventEmitter();

    @Output()
    public notify: EventEmitter<any> = new EventEmitter();

    /** text input */
    @Input()
    public limitChar: string;
    @Input()
    public maxlength: string;

    /** text chips, but can be general */
    @Input()
    public setMaj: boolean;

    /** Have to be general , to manage focus */
    @Input()
    public focusName: string;
    /** Have to be general , to manage focus */
    @Input()
    public focusOnMe: string;

    @Input()
    public excludeValue: any;

    @Input()
    public dropdown: boolean = false;

    @Input()
    public customTemplate: boolean;

    @Input()
    public autoDisplayFirst: boolean = false;

    /** to make multiSelect only one item selectable */
    @Input()
    public single: boolean = false;
    /** multiSelect, search also in value */
    @Input()
    public searchInValue: boolean = false;
    /** min number of cars before acction */
    @Input()
    public minNbChars: number = 0;
    /** when a field need to call an API */
    @Input()
    public apiName: string;


    @ViewChild('autoField', {static: true, read: AutoComplete}) public autoField: AutoComplete;

    @ViewChild('field', {static: true}) public field: any;

    public Yii = Yii;

    /**
     * @type {Subscription}
     * @private subscription
     */
    public subscription: Subscription;

    constructor() {
        //
    }


    /**
     * standar behaviour
     *
     */
    public onBlur($event): void {
        this.blur.emit($event);
    }
    public onFocus(event): void {
        this.focus.emit(null);
    }

    public onChange(_event: Event): void {
        this.change.emit(_event);
    }

    public onSelect($event: boolean): void {
        this.select.emit($event);
    }

    public onSelectDate($event: Event): void {
        //
    }

    public onKeyup($event: Event): void {
        this.keyUp.emit($event);
    }

    public onInputChange($event: Event): void {
        this.inputChange.emit($event);
    }

    /**
     * onlyNumberKey
     *
     * force nuber charCode
     * https://stackoverflow.com/questions/37435529/angular2-proper-way-to-restrict-text-input-values-e-g-only-numbers
     * 48 to 53 : numbers
     * 13= Enter
     */
    public onlyNumberKey(_event: any): any {

        const isNumberKey = (_event.charCode === 8 || _event.charCode === 0) ?
            false :
            ((_event.charCode >= 48 && _event.charCode <= 57) || _event.charCode === 13);

        return isNumberKey;
    }


    /**
     * only Alpha numeric keys
     * @param _event
     * @returns {any}
     */
    public onlyAlphanumeric(_event: any): any {
        const isLetter: boolean = (_event.which >= 97 && _event.which <= 122);
        const isNumber: boolean = (_event.which >= 48 && _event.which <= 57);
        if (isLetter || isNumber) {
            return _event.which;
        } else {
            return false;
        }
    }

    /**
     * test pressed chars before Angular trigger them
     ***/
    public testChar(_event: any): any {

        switch (this.limitChar) {
            case 'integer':
                return this.onlyNumberKey(_event);
            case 'alphanumeric':
                return this.onlyAlphanumeric(_event);
            default:
                break;
        }

    }

    /**
     * limit
     *
     * limit min and max while typing
     ***/
    public testValue(_min: number, _max: number, _event: any): boolean {
        let lower: boolean = false;
        let upper: boolean = false;
        const value = _toNumber(_toString(this.group.get(this.controlName).value) + _event.key);

        if (_min && value < _min) {
            lower = true;
        }
        if (_max && value > _max) {
            upper = true;
        }

        if (lower || upper) {
            return false;
        } else {
            return true;
        }

    }

    public ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public modifChar(): void {
        if (this.setMaj) {
            const oldValue = this.group.get(this.controlName).value;
            const newValue = _toUpper(oldValue);
            this.group.get(this.controlName).patchValue(newValue);
        }
    }

    /**
     * Check with 'path' is touched && has Error
     * @param {string} _path : path to the field
     * @param {string} _errorName : error to catch
     * @returns {boolean}
     */
    public getError(_path: string | any[], _errorName: string): boolean {

        return this.group.get(_path).touched && this.group.get(_path).hasError(_errorName);

    }
}
